import { useEffect, useState } from "react";
import api from "@/lib/api";

export function UndertakerRank({ onPick }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/ranked/undertakers").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);
  return (
    <div className="mt-10" data-testid="undertaker-rank">
      <p className="text-sm uppercase tracking-widest mb-6" style={{ color: "var(--text-primary)" }} data-testid="undertaker-rank-title">
        top 10 undertakers
      </p>
      <div className="flex flex-col gap-2" data-testid="undertaker-rank-list">
        {items === null ? (
          <p className="text-sm" style={{ color: "var(--text-muted)" }}>Loading…</p>
        ) : items.length === 0 ? (
          <p className="text-sm" style={{ color: "var(--text-muted)" }} data-testid="undertaker-rank-empty">No undertakers yet.</p>
        ) : (
          items.map((u, i) => (
            <button key={u.id} onClick={() => onPick(u.id)} data-testid={`undertaker-rank-row-${i}`} className="flex items-center justify-between gap-4 px-4 py-3 text-left transition-colors" style={{ border: "1px solid var(--border)" }}>
              <span className="flex items-center gap-4 min-w-0">
                <span className="text-sm shrink-0" style={{ color: "var(--text-muted)", width: "2ch" }}>{i + 1}</span>
                <span className="text-sm truncate" style={{ color: "var(--text-primary)" }}>{u.name}</span>
              </span>
              <span className="text-xs shrink-0 tracking-widest" style={{ color: "var(--accent)" }} data-testid={`undertaker-rank-stats-${i}`}>
                {u.completed} completed
              </span>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
